<template>
  <div class="popover affix-box">
    <div class="hm-affix" v-if="!isH5" :style="ifShowVideo ? '' : 'pointer-events: none;'">
      <div class="hm-video" :class="{AIVideo: AIKey}" v-if="ifShowVideo">
        <span class="close-btn" @click.stop="onCloseVideo">X</span>
        <div class="video-wrap">
          <hmVideo :type="videoKey" :AIKey="AIKey"/>
        </div>
      </div>
    </div>

    <div class="float-modal">
      <div class="showWindow1" v-show="showWindow1 && !showMont">
        <hm-img type="images" imgName="news_gzh_01_zh" imgClass="gzh-icon"/>
        <div class="title">华盟公众号</div>
      </div>
      <div class="showWindow2" v-show="showWindow2 && !showMont">
        <div class="flex-box">
          <hm-img type="icons" imgName="consult" imgClass="icon-contact" />
          <div class="flex-text">
            <div class="title">咨询热线</div>
            <div class="text">
              <span class="numb">400-628-8680</span>
            </div>
          </div>
        </div>
        <div class="flex-box">
          <hm-img type="icons" imgName="channel" imgClass="icon-contact" />
          <div class="flex-text" style="margin-top: 8PX;">
            <div class="title">渠道加盟</div>
            <div class="text">
              <span class="numb">189-2383-0202</span>
            </div>
          </div>
        </div>
      </div>
      <div class="showWindow3 show-pc" v-if="showMont" :class="leaveModal3">
        <div class="model_top">
          <div class="call">联系我们</div>
          <div class="close" @click="closeTous">
            <!-- <img src="@/assets/icon/2025.png" alt="" /> -->
            <hm-img type="icons" imgName="close" @click="closeTous"/>
          </div>
        </div>
        <div class="message">请留下联系方式，我们将尽快与您联系！</div>
        <div class="apply-form">
          <Apply :showAgreement="false" :showLabel="['phoneNo', 'verificationCode', 'remark']"/>
        </div>
      </div>
    </div>
    <div class="hm-affix-list"  @mouseleave="mouseleave" v-if="!isH5">
      <div class="hm-affix-list-item video-item" @click.stop="showVideo" @mouseenter="mouseleave">
        <p class="tooltips">华盟·税纪云介绍</p>
        <div class="icon-wrap">
          <!-- <img class="icon" :src="require(`@/assets/icons/video_icon2.png`)"> -->
          <hm-img type="icons" imgName="video_icon2" imgClass="icon-img-popover"/>
        </div>
      </div>
      <div class="hm-affix-list-item">
        <div class="btn">
          <div class="codeBox">
            <div class="msg" @click="closeTous" @mouseenter="mouseenter(1)">
              <hm-img type="icons" imgName="icon-gzh" imgClass="icon-img-popover" v-if="!showWindow1" />
              <hm-img type="icons" imgName="icon-gzh-active" imgClass="icon-img-popover" v-else />
            </div>
          </div>
          <div class="font"></div>
          <div class="phoBox">
            <div class="msg" @click="closeTous" @mouseenter="mouseenter(2)">
              <hm-img type="icons" imgName="icon-popver-phone" imgClass="icon-img-popover" v-if="!showWindow2" />
              <hm-img type="icons" imgName="icon-popver-phone-active" imgClass="icon-img-popover" v-else />
            </div>
          </div>
          <div class="font1"></div>
          <div class="msgBox">
            <div class="msg" @click="closemsg" @mouseenter="mouseenter(3)">
              <div class="icon-wrap wrap-contact">
                <hm-img type="icons" imgName="icon-contact2" imgClass="icon-img-popover"/>
              </div>
            </div>
          </div>
        </div>
        <div class="backTopBox" @mouseenter="mouseenter(4)">
          <div class="backTop" @click="backTop" @mouseenter="mouseenter(4)">
            <hm-img type="icons" imgName="icon-back-top" imgClass="icon-img-popover-back"/>
          </div>
        </div>
      </div>
    </div>

    <div class="h5-popver" v-if="isH5">
      <!-- 视频弹窗 -->
      <div class="hm-video" v-if="ifShowVideo">
        <span class="close-btn" @click.stop="onCloseVideo">X</span>
        <div class="video-wrap">
          <hmVideo :type="videoKey" :AIKey="AIKey" :width="AIKey ? 388 : 690" :height="AIKey ? 380 : 388"/>
        </div>
      </div>
      <div class="icon-wrap-img icon-tell" v-if="showAreaIcon" @click="mouseClickH5(1)">
        <hm-img type="images" imgName="popover_iconh5_01_zh" imgClass="icon-img-popover"/>
      </div>
      <div class="icon-wrap-img icon-code"  v-if="showAreaIcon" @click="mouseClickH5(3)">
        <hm-img type="images" imgName="popover_iconh5_02_zh" imgClass="icon-img-popover"/>
      </div>

      <!-- 电话弹窗 -->
      <div class="h5-modal-1" v-show="showModalH51" :class="leaveh5Modal1">
        <div class="tel-infomation">
          <div class="tel-title">
            欢迎致电 华盟竭诚为您服务
          </div>
          <div class="tel-box">
            <div class="sub-title">
              咨询热线
            </div>
            <div class="tel-number" @click="mouseClickH5(2, '4006288680')">
              400 6288 680
            </div>
          </div>
          <div class="tel-box">
            <div class="sub-title">
              渠道加盟
            </div>
            <div class="tel-number" @click="mouseClickH5(2, '18923830202')">
              189 2383 0202
            </div>
          </div>
        </div>
        <div class="left-close" @click="claseModalH51">
          <hm-img type="images" imgName="popover_iconclose_01_zh" imgClass="icon-pop-close"/>
        </div>
      </div>

      <!-- 拨打电话弹窗 -->
      <div class="mask-tel-modal" v-show="showModalH52" :class="leaveh5Modal2">
        <div class="tel-content">
          <div class="to-call a-line">
            <hm-img type="icons" style="display: inline-block" imgName="icon-popver-phone" imgClass="icon-popver-h5-phone" />
            <a class="tell" :href="phoneCallNoHref" @click="claseModalH52">
              呼叫 {{ phoneCallNo }}
            </a>
          </div>
          <div class="cancel a-line" @click="claseModalH52">取消</div>
        </div>
      </div>

      <!-- 公众号弹窗 -->
      <div class="h5-modal-3" v-show="showModalH53" :class="leaveh5Modal3">
        <div class="gzh-infomation">
          <hm-img type="images" imgName="news_gzh_01_zh" imgClass="gzh-icon"/>
          <div class="title">华盟公众号</div>
        </div>
        <div class="left-close" @click="claseModalH53">
          <hm-img type="images" imgName="popover_iconclose_01_zh" imgClass="icon-pop-close"/>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="show_user_h5 show-h5" v-if="showMont">
      <div class="show_user_content">
        <div class="model_top">
          <div class="call">联系我们</div>
          <div class="close_h5" @click.stop="closeTous"><hm-img type="images" imgName="home_service_icon_08_h5_zh" imgClass="icon_h5_style" /></div>
        </div>
        <div class="message">请留下联系方式，我们将尽快与您联系！</div>
        <div class="apply-form">
          <Apply :showAgreement="false" :showLabel="['phoneNo', 'verificationCode', 'remark']" :isShowLabelText="false"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {GetSendVerificationCode, PostProbationQuestions} from '@/api/api'
import Apply from '@/components/hm-apply'
import { mapGetters } from 'vuex'
const baseURL = 'https://player.bilibili.com/player.html?'
export default {
  data () {
    return {
      showMont: false,
      checked: true,
      isClose: false,
      form: {
        phone: '',
        code: '',
        name: '',
        componyName: ''
      },
      totle: 60,
      timer: 60,
      showWindow1: false,
      showWindow2: false,
      showWindow3: false,
      ifShowVideo: false,
      leaveModal3: '', // 出场动画
      showModalH51: false,
      showModalH52: false,
      showModalH53: false,
      leaveh5Modal1: '',
      leaveh5Modal2: '',
      leaveh5Modal3: '',
      videoKey: '',
      AIKey: '',
      phoneCallNo: ''
    }
  },
  watch: {
    showContact: {
      handler (val) {
        if (val) {
          this.showMont = val
        }
      },
      deep: true
    },
    showMont: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('setShowContact', false)
        }
      },
      deep: true
    },
    '$route' () {
      this.closeTous()
    }
  },
  computed: {
    phoneCallNoHref ({phoneCallNo}) {
      return `tel:${phoneCallNo}`
    },
    videoSrc () {
      return `${baseURL}cid=1003142190&aid=435109977&danmaku=0&as_wide=1`
    },
    ...mapGetters(['showContact', 'isH5','showAreaIcon'])
  },
  created () {
    this.$bus.$off('onShowVideo')
    this.$bus.$on('onShowVideo', (videoKey, AIKey) => {
      console.log('%c监听打开视频', 'background-color: green;', videoKey, AIKey)
      if (videoKey === 'AI') {
        this.videoKey = videoKey
        this.AIKey = AIKey
      } else {
        let keyString = videoKey === 'video-shop' ? 'shop' : videoKey === 'video-helper' ? 'helper' : 'product'
        this.videoKey = keyString
        this.AIKey = undefined
      }
      this.showVideo()
    })

    this.$bus.$on('onShowApply', () => {
      this.showMont = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('onShowVideo')
    this.$bus.$off('onShowApply')
  },
  components: {
    Apply
  },
  methods: {
    mouseenter (value) {
      if (value === 1) {
        this.showWindow1 = true
        this.showWindow2 = false
        this.showWindow3 = false
      }
      if (value === 2) {
        this.showWindow1 = false
        this.showWindow2 = true
        this.showWindow3 = false
      }
      if (value === 3) {
        this.showWindow1 = false
        this.showWindow2 = false
        this.showWindow3 = true
      }
      if (value === 4) {
        this.showWindow1 = false
        this.showWindow2 = false
        this.showWindow3 = false
      }
    },
    mouseClickH5 (value, num) {
      // 弹窗
      if (value === 1) {
        this.claseModalH53()
        if (this.showModalH51) {
          this.claseModalH51()
        } else {
          this.showModalH51 = true
        }
        return
      }
      if (value === 2) {
        this.claseModalH51()
        this.claseModalH53()
        if (this.showModalH52) {
          this.claseModalH52()
        } else {
          this.showModalH52 = true
          this.phoneCallNo = num
        }
        return
      }
      if (value === 3) {
        this.claseModalH51()
        if (this.showModalH53) {
          this.claseModalH53()
        } else {
          this.showModalH53 = true
        }
      }
    },
    claseModalH51 () {
      this.leaveh5Modal1 = 'hide-h5-modal1'
      setTimeout(() => {
        this.leaveh5Modal1 = ''
        this.showModalH51 = false
      }, 0)
    },
    claseModalH52 () {
      this.leaveh5Modal2 = 'hide-h5-modal2'
      setTimeout(() => {
        this.leaveh5Modal2 = ''
        this.showModalH52 = false
      }, 0)
    },
    claseModalH53 () {
      this.leaveh5Modal3 = 'hide-h5-modal1'
      setTimeout(() => {
        this.leaveh5Modal3 = ''
        this.showModalH53 = false
      }, 0)
    },
    mouseleave () {
      this.showWindow1 = false
      this.showWindow2 = false
      this.showWindow3 = false
    },
    backTop () {
      // let that = this
      // window.addEventListener('wheel', function (e) {
      //   clearInterval(that.timer)
      // })
      // this.timer = setInterval(function () {
      //   let osTop =
      //     document.documentElement.scrollTop || document.body.scrollTop;
      //   let ispeed = Math.floor(-osTop / 15);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     osTop + ispeed;
      //   if (osTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 10);
      var timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 10)
    },
    postcode () {
      if (this.form.phone === '') {
        return this.$message.error('请输入手机号')
      } else if (this.form.phone.length !== 11) {
        return this.$message.error('请输入正确的11位手机号')
      } else {
        this.GetSendVerificationCodeFun()
      }
    },
    closeTous () {
      this.leaveModal3 = 'hide-modal3'
      setTimeout(() => {
        this.leaveModal3 = ''
        this.showMont = false
      }, 400)
    },
    submit () {
      if (this.form.code === '') {
        return this.$message.error('请输入验证码')
      } else if (this.form.componyName === '') {
        return this.$message.error('请输入企业名称')
      } else if (this.checked === false) {
        return this.$message.error('请阅读并同意下方的《隐私政策》，并勾选确认。')
      } else {
        this.PostProbationQuestionsFun()
      }
    },
    GetSendVerificationCodeFun () {
      GetSendVerificationCode({
        'phoneNo': this.form.phone
      }).then(res => {
        console.log(res)
        if (res) {
          if (res.code === '200') {
            let num = setInterval(() => {
              if (this.totle > 0) {
                this.totle--
              } else {
                clearInterval(num)
                this.totle = 60
              }
            }, 1000)
            this.$message.success('验证码获取成功')
          } else {
            return this.$message.error(res.msg)
          }
        }
      })
    },
    PostProbationQuestionsFun () {
      PostProbationQuestions({
        'name': this.form.name,
        'phoneNo': this.form.phone,
        'verificationCode': this.form.code,
        'enterpriseName': this.form.componyName
      }).then(res => {
        console.log(res)
        if (res && res.code === '200') {
          this.$message.success('提交成功')
        } else {
          return this.$message.error(res.msg)
        }
      })
    },
    checkChange (e) {
      this.checked = e.target.checked
    },
    closemsg () {
      console.log('this.showMont', this.showMont)
      if (this.showMont) {
        this.closeTous()
      } else {
        this.showMont = true
      }
    },
    showVideo () {
      this.ifShowVideo = true
    },
    hideVideo () {
      this.ifShowVideo = false
    },
    onCloseVideo () {
      console.log('%c关闭视频', 'background-color: green;')
      this.hideVideo()
    }
  }
}
</script>

<style lang="less" scoped>
#hm-web{
  .affix-box {
    .show_user_h5 {
      position: fixed;
      top: 15%;
      left: 0%;
      padding: 0 40px;
      z-index: 30;
      .show_user_content {
        width: 670px;
        height: 730px;
        background-color: #FFFFFF;
        box-shadow: 0px 1px 16px 0px rgba(216,221,230,1);
        border-radius: 16px;
        // overflow: hidden;
        text-align: center;
        pointer-events: auto;
        .model_top {
          width: 100%;
          height: 96px;
          position: relative;
          border-radius: 16px 16px 0 0;
          background-color: #3d77ff;
          .call {
            font-family: PingFangSC-Medium;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            line-height: 96px;
            font-weight: 500;
          }
          .close_h5 {
            position: absolute;
            height: 48px;
            width: 48px;
            top: 0%;
            right: 0%;
            transform: translate(40%, -40%);
          }
        }
        .message {
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #292F3A;
          line-height: 40px;
          font-weight: 400;
          text-align: left;
          padding: 40px 32px;
        }
        .apply-form{
          pointer-events: auto;
        }
      }
    }
    .float-modal{
      width: 450PX;
      height: 650PX;
      z-index: 20;
      position: fixed;
      right: 26PX;
      bottom: 50PX;
      pointer-events: none;
    }
    .hm-affix-list {
      width: 100PX;
      position: fixed;
      right: 26PX;
      bottom: 400PX;
      z-index: 25;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .hm-affix-list-item {
        position: relative;
        width: 55PX;
        height: 55PX;
        margin-bottom: 15PX;
        .tooltips {
          position: absolute;
          top: -30PX;
          right: -32PX;
          width: 120PX;
          padding: 0 8PX;
          background-color: rgba(0, 0, 0, .4);
          color: #fff;
          border-radius: 3PX;
          opacity: 0;
          transition: all .3s cubic-bezier(0.39, 0.575, 0.565, 1);
        }
        &.video-item:hover {
          .tooltips {
            opacity: 1;
          }
        }
      }
      /deep/ .hm-picture{
        width: 100%;
        // background: blue;
        text-align: center;
        display: inline-block;
      }
      /deep/ .icon-img-popover{
        width: 18PX;
        height: 18PX;
      }
      /deep/ .icon-img-popover-back{
        width: 12PX;
        height: 10PX;
      }
    }
    .icon-wrap {
      margin: 0 auto;
      width: 48PX;
      height: 48PX;
      background-image: linear-gradient(347deg, #3e77ff 0%, #4e9cff 100%);
      box-shadow: 0PX 2PX 2PX 0PX rgba(19, 67, 123, 0.27);
      border-radius: 50%;
      transition: all 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      text-align: center;
      &:hover{
        width: 55PX;
        height: 55PX;
      }
      /deep/ .icon-img-popover {
        width: 24PX;
        height: auto;
      }
    }
    .wrap-contact{
      margin: 10PX auto;
    }
    .showWindow1 {
      text-align: center;
      width: 200PX;
      height: 231PX;
      background-color: #ffffff;
      box-shadow: 0PX 3PX 6PX 0PX rgba(0, 0, 0, 0.16);
      border-radius: 6PX;
      position: relative;
      // padding: 20PX;
      padding-top: 14PX;
      margin: 50PX 0 0 150PX;
      transition: all 0.5s ease;
      img {
        margin-top: 10PX;
      }

      /deep/.gzh-icon{
        width: 180PX;
        height: 180PX;
        margin: 0 auto;
        display: block;
      }
      .title {
        font-family: PingFang SC;
        font-size: 14PX;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0PX;
        color: #292f3a;
      }
    }
    .showWindow3 {
      text-align: center;
      width: 356PX;
      height: 450PX;
      background-color: #ffffff;
      box-shadow: 0PX 3PX 6PX 0PX rgba(0, 0, 0, 0.16);
      border-radius: 6PX;
      padding-bottom: 20PX;
      // transition: all 0.5s ease;
      animation-name: move;
      animation-duration: 0.3s;
      -webkit-animation-duration: 0.3s;
      animation-iteration-count: 1;
      animation-timing-function: cubic-bezier(0, 0, 0, 0);
      overflow: hidden;
      overflow-y: scroll;
      pointer-events: auto;
      position: relative;
      .model_top {
        display: flex;
        justify-content: space-between;
        width: 356PX;
        height: 60PX;
        text-indent: 20PX;
        background-color: #3d77ff;
        border-radius: 6PX 6PX 0PX 0PX;
        line-height: 60PX;
        font-family: PingFang SC;
        font-size: 16PX;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0PX;
        color: #ffffff;
        text-align: left;
        .call {
          // width: 30PX;
          // height: 30PX;
          // font-size: 20PX;
        }
        .close {
          color: #ffffff;
          width: 30PX;
          height: 30PX;
          margin-right: 30PX;
          cursor: pointer;
        }
      }
      .message {
        font-family: PingFang SC;
        width: 308px;
        height: 50px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 50px;
        letter-spacing: 0px;
        color: #666666;
      }
      .apply-form{
        padding: 24px;
        pointer-events: auto;
      }
      .model {
        margin: 0 auto;
        // background: red;
        width: 308px;
        height: 370px;
        .inputcode{
          margin-top: 15px;
          height: 36px;
            width: 308px;
            // border: 1px solid red;
            border: 1px solid #d8dde6;
            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            input {
              text-indent: 10px;
              border: none;
              outline: none;
              width: 200px;
              height: 36px;
              background-color: transparent;
              // margin-left: 20px;
            }
            .getCode{
              margin-top: -1px;
              cursor: pointer;
              color: #ffffff;
              outline: none;
              height: 36px;
              width: 100px;
              border: none;
              background: #3d77ff;

              //  margin-right: -10px;
            }
          }
        .model_input1 {
          height: 90px;
          width: 308px;
        margin-top: -5px;
          .code {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .text {
            width: 308px;
            height: 50px;
            font-family: PingFang SC;
            font-size: 14px;
            text-align: left;
            text-indent: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #333333;
            span {
              color: red;
              line-height: 50px;
              // text-align: center;
              // margin-top: 3px;
              padding-right: 5px;
            }
          }
          .input {
            margin-top: -5px;
            text-align: left;
            width: 308px;
            height: 36px;
            border-radius: 5px;
            border: 1px solid #d8dde6;
            input {
              text-indent: 10px;
              border: none;
              outline: none;
              width: 308px;
              height: 36px;
              background-color: transparent;
              // margin-left: 20px;
            }
          }
        }
        .model_input {
          height: 90px;
          width: 308px;
        //  margin-top: 5px;
          .code {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .text {
            width: 308px;
            height: 50px;
            font-family: PingFang SC;
            font-size: 14px;
            text-align: left;
            text-indent: 5px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #333333;
            span {
              color: red;
              line-height: 50px;
              // text-align: center;
              // margin-top: 3px;
              padding-right: 5px;
            }
          }
          .input {
            margin-top: -5px;
            text-align: left;
            width: 308px;
            height: 36px;
            border-radius: 5px;
            border: 1px solid #d8dde6;
            input {
              text-indent: 10px;
              border: none;
              outline: none;
              width: 308px;
              height: 36px;
              background-color: transparent;
              // margin-left: 20px;
            }
          }
        }
        .model_input3 {
          height: 100px;
          width: 308px;
          margin-top: 5px;
          .code {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .text {
            width: 308px;
            height: 50px;
            font-family: PingFang SC;
            font-size: 14px;
            text-align: left;
            text-indent: 5px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 0px;
            color: #333333;
            span {
              color: red;
              line-height: 50px;
              // text-align: center;
              // margin-top: 3px;
              padding-right: 5px;
            }
          }
          .input {
            margin-top: -5px;
            text-align: left;
            width: 308px;
            height: 36px;
            border-radius: 5px;
            border: 1px solid #d8dde6;
            input {
              text-indent: 10px;
              border: none;
              outline: none;
              width: 308px;
              height: 36px;
              background-color: transparent;
              // margin-left: 20px;
            }
          }
        }
      }
      .submit {
        // margin-top: 70px;
        width: 308px;
        height: 40px;
        background-color: #3e77ff;
        box-shadow: 0px 2px 3px 0px rgba(0, 119, 255, 0.27);
        border-radius: 6px;
        font-size: 20px;
        line-height: 40px;
      }
    }
    .showWindow3::-webkit-scrollbar {
      display: none;
      }
    .hide-modal3{
      animation-name: leave;
      animation-duration: 0.5s;
    }
    @keyframes move {
      0% {
        opacity: 0;
        right: -485px;
      }
      100% {
        opacity: 1;
        right: 0px;
      }
    }
    @keyframes leave {

      0% {
        opacity: 1;
        right: 0;
      }
      100% {
        opacity: 0;
        right: -485px;
      }
    }
    .showWindow2 {
      width: 240PX;
      height: 170PX;
      background-color: #ffffff;
      box-shadow: 0PX 3PX 6PX 0PX rgba(0, 0, 0, 0.16);
      border-radius: 6PX;
      position: relative;
      padding: 20PX;
      padding-top: 18PX;
      margin: 250PX 0 0 112PX;
      transition: all 0.5s ease;
      .flex-box {
        display: flex;
        justify-content: flex-start;
        align-items: end;
      }
      .flex-text {
        margin-left: 16PX;
      }
      /deep/ .icon-contact {
        width: 48PX;
      }
      .title {
        padding-top: 5PX;
        font-family: PingFang SC;
        font-size: 16PX;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36PX;
        letter-spacing: 0PX;
        color: #292f3a;
      }
      .text {
        .numb {
          font-family: PingFang SC;
          font-size: 18px;
          font-weight: bolder;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #3d77ff;
        }
        .name {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #999999;
        }
      }
    }
    .btn {
      width: 56PX;
      height: 180PX;
      background-color: #ffffff;
      box-shadow: 0PX 2PX 1PX 0PX rgba(19, 67, 123, 0.15);
      border-radius: 28PX;
      border: solid 1PX #f0f0f0;
      margin-bottom: 15PX;
      // position: absolute;
      // right: 0;
      // bottom: 0;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: space-around;
      .codeBox {
        margin: 0 auto;
        margin-top: 20PX;
        // padding-top: 40PX;
        width: 56PX;
        // margin-top: 10PX;

        // height: 20PX;
        text-align: center;
        // margin-bottom: 15PX;
      }
      .font {
        width: 30PX;
        height: 2PX;
        margin: 10PX auto 10PX;
        // margin-top: 10PX;
        // margin-bottom: 10PX;
        border-top: 1PX solid #e5e5e5;
      }
      .font1 {
        width: 30PX;
        height: 2PX;
        // margin-top: 10PX;
        margin: 10PX auto 5PX;

        // margin-bottom: 10PX;
        border-top: 1PX solid #e5e5e5;
      }
      .phoBox {
        margin: 0 auto;
        margin-top: 20PX;
        text-align: center;
        width: 56PX;
        // height: 22PX;
        // padding-top: 25PX;

        margin-bottom: 20PX;
      }
      .msgBox {
        cursor: pointer;
        text-align: center;
        width: 100%;
        height: 30px;
      }
      .toUsimg{
        margin-top: 2px;
        width: 50px;
      }
      .toUsimg:hover{
        width: 60px;
        margin-top: 2px;

        // padding-right: 6px;
        margin-left: -5px;
      }
    }
    .backTop {
      margin: 0 auto;
      width: 32PX;
      height: 32PX;
      background-color: #ffffff;
      box-shadow: 0PX 2PX 2PX 0PX #c2d0ea;
      border-radius: 3PX;
      border: solid 1PX #f1f5fd;
      //   margin-top: 20PX;
      transition: all 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .backTopBox {
        position: absolute;
        right: 0;
        bottom: -100PX;
        .backTopBox {
          text-align: center;
          width: 40PX;
          height: 40PX;
        }
      }
    }
    .backTop:hover {
      width: 34PX;
      height: 34PX;
    }
    .hm-affix {
      position: fixed;
      right: 26PX;
      bottom: 50PX;
      z-index: 9999999;
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    .hm-video {
      width: 100vh;
      height: 60vh;
      max-width: 1200PX;
      max-height: 705PX;
      border-radius: 15PX;
      .video-wrap {
        width: 100%;
        height: calc(100% - 30PX);
        overflow: hidden;
        border-radius: 15PX;
      }
      .video-iframe {
        width: 100%;
        min-width: 300PX;
        // 因为要隐藏b站播放器底部的提示, 所以要多加40PX, 如果要隐藏控件则多加30PX
        height: calc(100% + 40PX);
        box-sizing: border-box;
      }
      .close-btn {
        position: relative;
        top: 15PX;
        right: -10PX;
        display: block;
        float: right;
        width: 30PX;
        height: 30PX;
        line-height: 30PX;
        text-align: center;
        background-color: rgba(0, 0, 0, .2);
        color: #fff;
        border-radius: 50%;
        cursor: pointer;
        user-select: none;
        transition: all .3s cubic-bezier(0.39, 0.575, 0.565, 1);
        &:hover {
          background-color: rgba(0, 0, 0, .5);
        }
      }
      // 竖屏视频
      &.AIVideo {
        // max-height: auto;
        height: 100vh;
        .close-btn {
          // right: 255PX;
        }
      }
    }
    @media screen and (max-width: 1200px) {
      .h5-popver {
        position: fixed;
        right: 12px;
        bottom: 240px;
        display: flex;
        flex-direction: column;
        // justify-content: flex-end;
        align-items: flex-end;
        z-index: 10;
        .icon-wrap-img {
          width: 126px;
          height: 126px;
          /deep/ .icon-img-popover {
            width: 100%;
            height: auto;
          }
        }
        .hm-video {
          width: 96vw;
          height: 100vw;
          margin-bottom: 50px;

          .close-btn {
            right: 0;
          }
        }
        .h5-modal-1{
          position: fixed;
          bottom: 288px;
          right: 160px;
          // animation-name: h5move;
          // animation-duration: 0.5s;
          // -webkit-animation-duration: 0.5s;
          // animation-iteration-count: 1;
          // animation-timing-function: cubic-bezier(0, 0, 0, 0);
          /deep/ .icon-pop-close{
            width: 48px;
            height: 48px;
            z-index: 999;
          }
          .left-close{
            position: absolute;
            top: -16px;
            left: -16px;
          }
          .tel-infomation{
            width: 432px;
            position: relative;
            box-shadow: 0px 0px 16px 0px rgba(216,221,230,1);
            border-radius: 16px;
            border-top-left-radius: 0;
            overflow: hidden;
            background: #fff;
            .tel-title{
              width: 100%;
              height: 72px;
              line-height: 72px;
              font-size: 26px;
              color: #566073;
              background: #F5F9FF;
              padding-left: 60px;
            }
            .tel-box{
              height: 168px;
              background: #fff;
              font-size: 28px;
              color: #292F3A;
              padding: 32px 0 0 60px;
              .tel-number{
                margin-top: 16px;
                font-size: 32px;
                color: #236AFF;
              }
            }
            .tel-box + .tel-box{
              padding-top: 0;
            }
          }
        }
        .mask-tel-modal{
          background: rgba(0, 0, 0, 0.5);
          position: fixed;
          top:0;
          right: 0;
          bottom: 0;
          left: 0;
          // z-index: 999;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          // animation-name: h5move2;
          // animation-duration: 0.5s;
          // -webkit-animation-duration: 0.5s;
          // animation-iteration-count: 1;
          // animation-timing-function: cubic-bezier(0, 0, 0, 0);
          .a-line{
            width: 100%;
            height: 114px;
            line-height: 114px;
            background: #fff;
            border-radius: 24px;
            font-size: 40px;
            color: #007AFF;
            text-align: center;
            .tell{
              color: #007AFF;
            }
            /deep/ .icon-popver-h5-phone{
              width: 42px;
              margin-right: 16px;
              padding-bottom: 10px;
            }
          }
          .cancel{
            font-weight: 600;
            margin: 16px 0 60px 0;
          }
        }
        .h5-modal-3{
          position: fixed;
          bottom: 209px;
          right: 160px;
          // animation-name: h5move;
          // animation-duration: 0.5s;
          // -webkit-animation-duration: 0.5s;
          // animation-iteration-count: 1;
          // animation-timing-function: cubic-bezier(0, 0, 0, 0);
          /deep/ .icon-pop-close{
            width: 48px;
            height: 48px;
            z-index: 999;
          }
          .left-close{
            position: absolute;
            top: -16px;
            left: -16px;
          }
          .gzh-infomation{
            // width: 356px;
            padding: 30px;
            background-color: #fff;
            box-shadow: 0px 0px 16px 0px rgba(216,221,230,1);
            border-radius: 16px;
            border-top-left-radius: 0;
            overflow: hidden;
            text-align: center;
            /deep/ .gzh-icon{
              width: 280px;
              height: 280px;
            }
            .title{
              margin-top: 16px;
              font-size: 32px;
              color: #566073;
            }
          }
        }
        .hide-h5-modal1{
          // animation-name: h5leave;
          // animation-duration: 0.5s;
        }
        .hide-h5-modal2{
          // animation-name: h5leave2;
          // animation-duration: 0.5s;
        }
        @keyframes h5move {
          0% {
            opacity: 0;
            right: -485px;
          }
          100% {
            opacity: 1;
            right: 160px;
          }
        }
        @keyframes h5leave {
          0% {
            opacity: 1;
            right: 160px;
          }
          100% {
            opacity: 0;
            right: -485px;
          }
        }
        @keyframes h5move2 {
          0% {
            opacity: 0;
            bottom: -220px;
          }
          100% {
            opacity: 1;
            bottom: 0;
          }
        }
        @keyframes h5leave2 {
          0% {
            opacity: 1;
            bottom: 0;
          }
          100% {
            opacity: 0;
            bottom: -220px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
  #hm-web {
    .icon_h5_style {
      height: 100%;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popover.vue